export default "__VITE_ASSET__DoTAtYlY__"